(function () {
  function toggleItem(item, trigger) {
    var isOpen = item.classList.contains('is-open');
    item.classList.toggle('is-open', !isOpen);
    trigger.setAttribute('aria-expanded', String(!isOpen));
  }

  function init(root) {
    root.querySelectorAll('.content-faq__trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('.content-faq__item');
        if (item) toggleItem(item, trigger);
      });
    });
  }

  document.querySelectorAll('.content-faq').forEach(init);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.content-faq');
    if (root) init(root);
  });
})();
